class MRequestCustomSize extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      openButton: "[data-open-custom-size]",
      content: ".m-form-request-custom-size",
      container: ".m-product-secondary-actions",
      formSuccess: ".form-custom-size__success",
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    // Fallback: if not inside secondary actions, search closest product addon container
    this.container =
      document.querySelector(this.selectors.container) ||
      document.querySelector(".m-product-addon") ||
      document.body;
    this.colorScheme =
      (this.domNodes.content && this.domNodes.content.dataset.colorScheme) ||
      "";
    if (this.domNodes.content && this.domNodes.content.innerHTML) {
      this.content = this.domNodes.content.innerHTML;
      this.init();
    }
  }

  init() {
    this.showSuccessMessage();
    this.modal = new MinimogTheme.Modal();
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault();
        if (this.content) {
          const html = document.createElement("DIV");
          html.innerHTML = this.content;
          this.modal.appendChild(html);
          this.modal.setWidth("500px");
          this.modal.setSizes(
            `m-form-request-custom-size m-gradient ${this.colorScheme}`
          );
          this.modal.open();
        }
      },
    });
  }

  showSuccessMessage() {
    const successMessage = document.querySelector(
      this.selectors.formSuccess
    );
    if (successMessage) {
      MinimogTheme.Notification.show({
        target: document.body,
        method: "appendChild",
        type: "success",
        message: successMessage.dataset.message,
        delay: 2000,
        sticky: true,
      });

      setTimeout(() => {
        const url = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, url);
      }, 2500);
    }
  }
}
customElements.define("custom-size-request", MRequestCustomSize);


